import React from "react";
import { Box, HStack, Text, Image } from "@chakra-ui/react";
import { StatusBadge } from "./StatusBadge";
import { ActionButton } from "./ActionButton";

interface ClientInfoProps {
  name: string;
  status: string;
  email: string;
  phone: string;
}

export function ClientInfo({ name, status, email, phone }: ClientInfoProps) {
  return (
    <Box
      as="section"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      p={6}
      bg="white"
      width="254px"
      height="100%"
      flexShrink={0}
    >
      <Box>
        <HStack spacing={3} mb={6} align="center">
          <Image
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4ea6ae21d54573af189f20351e0c79abff562b08?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
            alt="Profile avatar"
            boxSize="40px"
            borderRadius="full"
            objectFit="cover"
            flexShrink={0}
          />
          <Text fontSize="lg" fontWeight="500" color="gray.700" noOfLines={1}>
            {name}
          </Text>
        </HStack>
        
        <Box mb={4}>
          <HStack spacing={2} mb={3}>
            <Text fontSize="sm" color="gray.800" flexShrink={0}>
              Status:
            </Text>
            <StatusBadge status={status} />
          </HStack>
        </Box>
        
        <Box>
          <Text fontSize="sm" color="gray.500" mb={2} noOfLines={1}>
            {email}
          </Text>
          <Text fontSize="sm" color="gray.500" noOfLines={1}>
            {phone}
          </Text>
        </Box>
      </Box>
      
      {/* <HStack spacing={2} mt={6}>
        <ActionButton
          text="Call"
          iconUrl={status === "Active" ? "https://cdn.builder.io/api/v1/image/assets/TEMP/5e83e3a08b55379af9be528ec70f3134dee97990?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9" : "https://cdn.builder.io/api/v1/image/assets/TEMP/6ddaf03e0f2664191e9901b028988f6efdaa7f02?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"}
        />
        <ActionButton
          text="Email"
          iconUrl={status === "Active" ? "https://cdn.builder.io/api/v1/image/assets/TEMP/bc85146c2f414bdc91ac81795bbbc5762a23046e?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9" : "https://cdn.builder.io/api/v1/image/assets/TEMP/6b8a45d094ff181450c34ea76bcc901ae7391947?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"}
        />
      </HStack> */}
    </Box>
  );
} 